// ProductCardComponentSleek.tsx
import React from "react";
import "./ProductCardComponentSleekStyles.css";
import ReactModal from "react-modal";
import ProductCardAdditionalOptions from "./ProductCardAdditionalOptions";
import { useTheme } from "../../hooks/ThemeContext";

type Props = {
    productId: string,
    productData: any,
    productName: string,
    productPrice: number | null, // Update type to allow null
    currencySymbol: string,
    menus: string[],
    activeMenu: string,
    productDescription?: string,
    productThumbnailUrl?: string,
    additionalOptions?: any[],
    userChoices?: any[],
    addToCart: any,
    menuSettings: any[],
    openingHours: any
}

const ProductCardComponentSleek = (props: Props) => {
    const { theme } = useTheme();
    const [showModal, setShowModal] = React.useState(false);

    // Check if price is valid
    const isPriceValid = props.productPrice !== null && props.productPrice !== undefined;

    const modalCustomStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            color: theme.cartTextColor,
            padding: '0',
            zIndex: 100000000,
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 100000000,
        }
    };

    const modalMediaQueryStyles = `
        @media (min-width: 768px) {
            .ReactModal__Content {
                height: 90dvh;
                max-width: 600px;
                width: 100%;
            }
        }
        
        @media (max-width: 767px) {
            .ReactModal__Content {
                height: 100dvh !important;
                width: 100% !important;
                max-width: 100% !important;
                max-height: 100dvh !important;
                top: 0 !important;
                left: 0 !important;
                right: 0 !important;
                bottom: 0 !important;
                transform: none !important;
                margin: 0 !important;
                border-radius: 0 !important;
                padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left) !important;
            }
            
            .ReactModal__Overlay {
                padding: 0 !important;
            }
        }
    `;

    const handleOrderClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setShowModal(true);
    };

    return (
        <>
            <div 
                className={`product-card-sleek-container ${!props.productThumbnailUrl ? 'no-image' : ''}`}
                style={{
                    backgroundColor: theme.cardColor,
                    border: `1px solid ${theme.borderColor}`,
                    cursor: isPriceValid ? 'pointer' : 'default', // Change cursor when not clickable
                    opacity: isPriceValid ? 1 : 0.6 // Optional: dim the card visually
                }}
                onClick={isPriceValid ? () => setShowModal(true) : undefined} // Only clickable if price is valid
            >
                {/* Product Image - Top Half - Only render if image exists */}
                {props.productThumbnailUrl && (
                    <div className="product-card-sleek-image-section">
                        <img 
                            src={props.productThumbnailUrl} loading="lazy" decoding="async" 
                            alt={props.productName}
                            className="product-card-sleek-image"
                        />
                    </div>
                )}

                {/* Content Section */}
                <div 
                    className={`product-card-sleek-content-section ${!props.productThumbnailUrl ? 'no-image' : ''}`}
                    style={{ backgroundColor: theme.cardColor }}
                >
                    <div className="product-card-sleek-info">
                        <h3 
                            className="product-card-sleek-title" 
                            style={{ color: theme.cartTextColor }}
                        >
                            {props.productName}
                        </h3>
                        {props.productDescription && (
                            <p 
                                className="product-card-sleek-description" 
                                style={{ color: theme.cartTextColor, opacity: 0.8 }}
                            >
                                {props.productDescription}
                            </p>
                        )}
                    </div>

                    <div className="product-card-sleek-footer">
                        {isPriceValid && props.productPrice && (
                            <span 
                                className="product-card-sleek-price" 
                                style={{ color: theme.cartTextColor }}
                            >
                                {props.currencySymbol}{props.productPrice.toFixed(2)}
                            </span>
                        )}
                        {isPriceValid && (
                            <button 
                                className="product-card-sleek-order-button"
                                onClick={handleOrderClick}
                                style={{
                                    backgroundColor: theme.payButtonColor,
                                    color: theme.payButtonTextColor
                                }}
                            >
                                Order
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {props.productPrice && <ReactModal isOpen={showModal} style={modalCustomStyles}>
                <style>{modalMediaQueryStyles}</style>
                    <ProductCardAdditionalOptions
                        onClose={() => { setShowModal(false) }}
                        productId={props.productId}
                        productData={props.productData}
                        productName={props.productName}
                        productDescription={props.productDescription}     // ← add
                        productThumbnailUrl={props.productThumbnailUrl}   // ← add
                        productPrice={props.productPrice!}
                        currencySymbol={props.currencySymbol}
                        menus={props.menus}
                        activeMenu={props.activeMenu}
                        additionalOptions={props.additionalOptions}
                        userChoices={props.userChoices}
                        addToCart={props.addToCart}
                        setModalOpen={setShowModal}
                        menuSettings={props.menuSettings}
                        openingHours={props.openingHours}
                    />
            </ReactModal>}
        </>
    );
};

export default ProductCardComponentSleek;